const TOUCH_CLICK_WINDOW_MS = 1000;

type TouchAwareEvent = Event & {
  pointerType?: string;
  sourceCapabilities?: {
    firesTouchEvents?: boolean;
  };
};

export const isTouchInteraction = (
  event: Event,
  lastTouchAt = 0,
  now = Date.now(),
): boolean => {
  const touchAwareEvent = event as TouchAwareEvent;
  const isRecentTouch = lastTouchAt > 0
    && now >= lastTouchAt
    && now - lastTouchAt <= TOUCH_CLICK_WINDOW_MS;

  return event.type.startsWith('touch')
    || touchAwareEvent.pointerType === 'touch'
    || touchAwareEvent.sourceCapabilities?.firesTouchEvents === true
    || isRecentTouch;
};
